// The DATE as the person at the screen sees it (16 Oct 2026, Rajan).
//
// `new Date().toISOString().slice(0, 10)` is the UTC date. In IST (UTC+5:30) that is yesterday's date
// from midnight to 05:30, and when the Date was built as a LOCAL midnight (new Date(y, m, 1),
// new Date('YYYY-MM-DDT00:00:00')) it is the previous day EVERY time: GateRegister's month start read
// the last day of the previous month, and Activity's "Next" did not move while "Previous" jumped two days.
// These read the local calendar date instead. Kept tiny on purpose; the other uses are migrated in
// later, separate changes.

const pad = (n) => String(n).padStart(2, '0');

// 'YYYY-MM-DD' of `d` in the browser's own time zone.
export const localDate = (d = new Date()) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// 'YYYY-MM-DD' n calendar days from `ymd` ('YYYY-MM-DD'), month and year boundaries included.
export const addDays = (ymd, n) => {
  const [y, m, d] = String(ymd).split('-').map(Number);
  return localDate(new Date(y, m - 1, d + n));
};
